export const GET_ORDERS_LIST_PENDING = 'GET_ORDERS_LIST_PENDING';
export type GET_ORDERS_LIST_PENDING = typeof GET_ORDERS_LIST_PENDING;

export const GET_ORDERS_LIST_FULFILLED = 'GET_ORDERS_LIST_FULFILLED';
export type GET_ORDERS_LIST_FULFILLED = typeof GET_ORDERS_LIST_FULFILLED;

export const GET_ORDERS_LIST_REJECTED = 'GET_ORDERS_LIST_REJECTED';
export type GET_ORDERS_LIST_REJECTED= typeof GET_ORDERS_LIST_REJECTED
